"use strict";

var _excluded = ["path", "resolve", "webpack"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* global __webpack_modules__ */
/* eslint-disable camelcase, no-underscore-dangle, no-multi-assign, consistent-return */
/**
 * Module dependencies
 */
var React = require('react');
var componentsReady = [];

/**
 * Check that webpack is ready and the modules can be load
 * @param {Function} resolveWeak
 * @returns {Number}
 */
var getWebpackModuleId = function getWebpackModuleId(resolveWeak) {
  if ((typeof __webpack_modules__ === "undefined" ? "undefined" : _typeof(__webpack_modules__)) !== 'object') {
    return null;
  }
  var moduleId = resolveWeak();
  if (typeof moduleId !== 'undefined' && typeof __webpack_modules__[moduleId] !== 'undefined') {
    return moduleId;
  }
  return null;
};

/**
 * Get the React Component wrapping the actual component
 * @param resolve
 * @param webpack
 * @returns {AsyncRouteComponent}
 */
var generateAsyncComponent = function generateAsyncComponent(_ref) {
  var resolve = _ref.resolve,
    webpack = _ref.webpack;
  var Component = null;
  function init() {
    return resolve().then(function (c) {
      Component = c;
      return c;
    })["catch"](function () {
      return Component;
    });
  }

  // As soon as the module starts and is webpackReady load the component
  if (typeof webpack === 'function') {
    var moduleId = getWebpackModuleId(webpack);
    // preloadAsyncComponent only admits to load 1 Async component
    if (moduleId) {
      componentsReady.push(new Promise(function (resolveFn) {
        return init().then(function () {
          return resolveFn(moduleId);
        });
      }));
    }
  }

  /**
   * Real React Component that is loaded async
   */
  return /*#__PURE__*/function (_React$PureComponent) {
    _inherits(AsyncComponent, _React$PureComponent);
    var _super = _createSuper(AsyncComponent);
    function AsyncComponent(props) {
      var _this;
      _classCallCheck(this, AsyncComponent);
      _this = _super.call(this, props);
      _this.state = {
        Component: Component
      };
      return _this;
    }
    _createClass(AsyncComponent, [{
      key: "render",
      value: function render() {
        var ComponentFromState = this.state.Component;
        if (ComponentFromState) {
          return React.createElement(ComponentFromState, this.props);
        }
        return null;
      }
    }], [{
      key: "preload",
      value: function preload() {
        return init();
      }
    }]);
    return AsyncComponent;
  }(React.PureComponent);
};

/**
 * Expose generateAsyncComponent
 */
exports = module.exports = generateAsyncComponent;

/**
 * Initialize Components from Webpack
 * @returns {Promise}
 */
var preloadAsyncComponent = function preloadAsyncComponent() {
  var promise = [];
  if (componentsReady.length > 0) {
    promise = componentsReady;
  }
  return Promise.all(promise).then(function (modules) {
    return modules;
  });
};

/**
 * Expose preloadAsyncComponent
 */
exports.preloadReady = preloadAsyncComponent;
if (process.env.NODE_ENV === 'test') {
  exports.componentsReady = componentsReady;
}

/**
 * This method build all routes for SPA,
 * so that the data would be loaded before the route handler was rendered
 * @function
 * @param {Array} componentRoutes - The component routes
 * @returns {Array}
 */
var buildAsyncRoutes = function buildAsyncRoutes() {
  var componentRoutes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return componentRoutes.filter(function (componentRoute) {
    return componentRoute.path && componentRoute.resolve && componentRoute.webpack;
  }).map(function (_ref2) {
    var path = _ref2.path,
      resolve = _ref2.resolve,
      webpack = _ref2.webpack,
      extra = _objectWithoutProperties(_ref2, _excluded);
    return _objectSpread(_objectSpread({}, extra), {}, {
      path: path,
      component: generateAsyncComponent({
        resolve: resolve,
        webpack: webpack
      })
    });
  });
};

/**
 * Expose buildAsyncRoutes
 */
exports.buildRoutes = buildAsyncRoutes;
